import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedQuery from './AuthorizedQuery';

const GQL = (props: Props) =>
  gql(`
  query Notifications {
    notifications {
      modifiedOn
      lastStatus
      type
      subject
      values
    }
  }
`);

interface Renders {
  notifications: Notification[] | null;
  loading: boolean;
  refetch: () => void;
}

interface Props {
  pollInterval?: number;
  children: (renders: Renders) => React.ReactNode;
}

const NotificationsProvider: React.StatelessComponent<Props> = (props: Props) => (
  <AuthorizedQuery query={GQL(props)} pollInterval={props.pollInterval}>
    {({ data, loading, refetch }) => {
      return props.children({
        notifications: data && data.notifications,
        loading,
        refetch
      });
    }}
  </AuthorizedQuery>
);

export default NotificationsProvider;



// WEBPACK FOOTER //
// ./src/providers/NotificationsProvider.tsx